import React, { useCallback, useState } from 'react';
import { Switch } from 'antd';
import { connect } from 'react-redux';

import { tableColumn } from 'utils';
import { TableList, ActionButton, DateTimeText, PropValue } from 'components/common';
import WarehouseValue from '../WarehouseValue';


const WarehouseList = ({ router, columnList, defaultFilter, activeFilter, topActions, actions, warehouse }) => {
  const defaultColumnList = ['name', 'date_synced', 'is_active', 'actions'];
  if (!columnList) {
    columnList = defaultColumnList;
  }
  const [itemIdForUpdate, setItemIdForUpdate] = useState(null);
  const columnByName = {
    id: tableColumn('ID', 'id', {
      sorter: true,
      width: 59,
    }),
    name: tableColumn('Название', 'name', {
      render: (val, item) => (
        <div>
          <WarehouseValue detail={item} asLink={true} isBack={true} />
          <PropValue label="EXT_ID" value={item.ext_id}/>
        </div>
      ),
      sorter: true,
    }),
    date_synced: tableColumn('Дата синхронизации', 'date_synced', {
      render: (val, item) => <DateTimeText date={val} />,
      width: 150,
      sorter: true,
    }),
    is_active: tableColumn('Активен', 'is_active', {
      sorter: true,
      width: 100,
      render: (val, item) => (
        <div>
          <Switch
            style={{ marginTop: '5px', minWidth: '62px' }}
            checkedChildren="вкл"
            unCheckedChildren="выкл"
            checked={item.is_active}
            loading={warehouse.updateStatus.isLoading && itemIdForUpdate === item.id}
            onClick={() => onWarehouseOnOff(item)}
          />
        </div>
      ),
    }),
    actions: tableColumn('', 'actions', {
      align: 'right',
      render: (val, item) => (
        <ActionButton detail={item} modelActions={actions.warehouse} actions={[{ name: 'edit' }, { name: 'delete' }]} />
      ),
    }),
  };

  const [selected, setSelected] = useState([]);

  const onLoad = useCallback(
    ({ query, activeFilter }) => {
      if (activeFilter === undefined) {
        activeFilter = warehouse.filter.activeFilter;
      }
      actions.warehouse.listLoad({ query, activeFilter, locationChange: true });
      setSelected([]);
    },
    [warehouse, actions, setSelected],
  );

  const onWarehouseOnOff = (item) => {
    const data = {
      id: item.id,
      is_active: !item.is_active,
      preventLoadDetail: true,
    };
    setItemIdForUpdate(item.id);
    actions.warehouse.update(data);
  };

  const batchDelete = (selected) => {
    actions.warehouse.batchDelete({ selected });
  };

  return (
    <TableList
      location={router.location}
      model={warehouse}
      defaultFilter={defaultFilter}
      activeFilter={activeFilter}
      columnList={columnList}
      columnByName={columnByName}
      onLoadData={onLoad}
      topActions={topActions}
      showSearch={true}
      selected={selected}
      rowSelection={{
        selectedRowKeys: selected,
        onChange: (selectedRowKeys, selectedRows) => {
          setSelected(selectedRowKeys.slice());
        },
      }}
      rowActions={[
        {
          title: 'Удалить',
          icon: 'delete',
          action: (selected) => batchDelete(selected),
        },
      ]}
      filterFields={{
        list: ['is_active'],
        byName: {
          is_active: {
            label: 'Активно',
            type: 'bool',
          },
        },
      }}
    />
  );
};

const mapState = (state) => ({
  router: state.router,
  warehouse: state.warehouse,
});

const mapDispatch = (dispatch) => ({
  actions: {
    warehouse: dispatch.warehouse,
  },
});

export default connect(mapState, mapDispatch)(WarehouseList);
